import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';

interface RequireAuthProps {
  children: React.ReactNode;
}

const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const { isAuthenticated, login } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    login();
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <p>Redirecting to sign in...</p>
      </div>
    );
  }

  return <>{children}</>;
};

export default RequireAuth;
